
import qrCode from '~/components/j/qrCode.vue'
export default {
  components: {
    'qr-code': qrCode
  },
  data() {
    return {
      LanguageCode: this.$store.state.LanguageCode, // 当前页面语言
      /* 扫码登录 */
      logo: 'https://resources1.interface003.com/web20/img/login/icon.svg',
      qrUrl: '', // 二维码地址
      qrToken: '', // 二维码token
      qrScanSucc: false, // 是否扫码成功
      refreshQR: false, // 是否刷新二维码
      websock: null // WebSocket配置项
    }
  },
  mounted() {
    // this.$nextTick(() => {
    this.qrTokenFn() // 获取二维码
    // })
  },
  methods: {
    // 二维码登录——获取二维码内容
    async qrTokenFn(i = 1) {
      this.refreshQR = this.qrScanSucc = false // 刷新二维码前的操作
      clearTimeout(this.qrTimer)
      const { result = {} } = await this.$api.login.userGetqrcode()
      console.log('result: ', result)
      const { Token: token = '', WikiQRType: qrType = '' } = result?.WikiFXQR || {}
      this.qrToken = token
      this.qrUrl = `${this.$store.state.host.includes('fxeye') ? `https://m.${this.$store.state.newhost}.com/download.html` : 'https://apphtml.0067.cc/mobile/download'}?languageCode=${this.LanguageCode}&countryCode=${this.$store.state.usergetCountry.countryCode}&qrid=${token}&type=${qrType}&app=usersite`
      if (i == 2) this.$refs.qrCode.setresetting(this.qrUrl)
      if (!this.websock) this.initWebSocket() // 初始化WebSocket
      this.qrTimer = setTimeout(() => {
        // 一分钟后二维码失效
        this.refreshQR = true
        this.websock = null
      }, 60000)
    },
    // WebSocket初始化
    initWebSocket() {
      this.websock = new WebSocket('wss://websocket.fx696.com')
      this.websock.onopen = () => {
        this.websock.send(JSON.stringify({ WikiFXQR: { Token: this.qrToken } }))
        this.heartTimer = setTimeout(this.heartBeat, 10000) // 开启心跳连接
      }
      this.websock.onerror = () => {
        this.reconnect() // 重新连接
      }
      this.websock.onmessage = (e = '') => {
        if (!e || !e.data) return false
        if (e.data == 1) {
          // 扫码成功
          this.refreshQR = false
          this.qrScanSucc = true
        } else if (e.data == 2) {
          // 取消授权
          this.qrScanSucc = false
          this.refreshQR = true
          this.websock = null
        } else this.getUCookie(e.data) // 获取登录信息
      }
      this.websock.onclose = () => {
        clearTimeout(this.heartTimer) // 清除心跳延时器
      }
    },
    reconnect() {
      clearTimeout(this.heartTimer)
      if (this.lockReconnect) return false
      this.lockReconnect = true
      const sockTime = setTimeout(() => {
        // 没连接上会一直重连，设置延迟避免请求过多
        clearTimeout(sockTime)
        this.initWebSocket()
        this.lockReconnect = false
      }, 2000)
    },
    async getUCookie(obj = {}) {
      const { CountryCode = '', LanguageCode = '' } = this.$store.state
      if (typeof obj != 'object') {
        const { result: uInfo = {} } = await this.$api.home.getUserinfoKh({
          UserId: obj,
          ApplicationType: 7,
          CountryCode,
          LanguageCode,
          Ppl: 7,
          Poy: 1
        })
        this.accessCookie(uInfo)
      }
    },
    async accessCookie(userInfo) {
      // 加密cookie存cookie
      this.$store.commit('setUser', {
        userId: userInfo.userId,
        nick: userInfo.showNickName || userInfo.nick,
        avatar: userInfo.showAvataraddress || userInfo.avatar
      })
      const {
        succeed = false,
        extra = '',
        result = {}
      } = await this.$api.login.userEncryption({
        userId: userInfo.userId,
        nick: userInfo.showNickName || userInfo.nick,
        avatar: userInfo.showAvataraddress || userInfo.avatar
      })
      if (!succeed) return this.$message.error(extra) // 数据错误
      if (this.$store.state.host.includes('wikifx')) {
        this.CookieSet('DJkdikKMG', result.Value, `.${this.$store.state.host.split('.')[1]}.${this.getSuffix(this.$store.state)}`)
      } else if (this.$store.state.host.includes('fxeye')) {
        this.CookieSet('ViLartidlakd', result.Value, `.${this.$store.state.host.split('.')[1]}.${this.getSuffix(this.$store.state)}`)
      } else {
        this.$cookies.set('WsdsfgDGdagYms', result.Value)
        // this.CookieSet(
        //   'WsdsfgDGdagYms',
        //   result.Value,
        //   `.${this.comurl}.${this.$store.state.my_domin}`
        // )
        const postdata = {
          op_type: 'setCookie',
          url: '',
          parm: result.Value
        }
        // console.log(123);
        window.parent.postMessage(postdata, '*')
      }
      // this.$message.success('登录成功')
      // 如果为login.html页面则跳转
      // if (this.$store.state.path == 'login.html') {
      //   this.$store.commit('setUCookie', result?.Value)
      //   setTimeout(() => {
      //   }, 200)
      // } else {
      this.$store.commit('setUsercookie', result?.Value)
      const postdata = {
        op_type: 'reload',
        url: '',
        parm: result?.Value
      }
      window.parent && window.parent.postMessage(postdata, '*')
      this.$emit('close')
      if (this.$store.state.path.includes('login.html')) {
        setTimeout(() => {
          if (process.client) location.href = `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/usercenter/index.html`
        }, 200)
      }
      // }
    },
    CookieSet(key, val, dom) {
      // 存cookie
      const expiresTime = new Date(Date.now() + 8.64e7 * 999)
      this.$cookies.set(key, val, {
        expires: expiresTime,
        path: '/',
        domain: dom
      })
    }
  }
}
